import { useState } from "react";
import "@/App.css";
import { C } from "./data/content";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { History } from "./components/History";
import { HistoryFull } from "./components/HistoryFull";
import { Landmarks } from "./components/Landmarks";
import { Market } from "./components/Market";
import { Listings } from "./components/Listings";
import { Living } from "./components/Living";
import { Team } from "./components/Team";
import { PartnerCTA, AboutAgency, Footer } from "./components/PartnerCTA";

function App() {
  const [lang, setLang] = useState("ro");
  const t = C[lang];

  return (
    <div className="App bg-copou-bg min-h-screen antialiased">
      <Nav lang={lang} setLang={setLang} t={t} />
      <Hero t={t} />
      <History t={t} />
      <HistoryFull t={t} />
      <Landmarks t={t} />
      <Market t={t} />
      <Listings t={t} lang={lang} />
      <Living t={t} lang={lang} />
      <Team t={t} lang={lang} />
      <PartnerCTA t={t} />
      <AboutAgency t={t} lang={lang} />
      <Footer t={t} />
    </div>
  );
}

export default App;
